import { IAmount } from '../money/IAmount';
import { AddressDetails } from './AddressDetails';

export interface IProfileExtraToApi {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneCountry?: string;
    phoneNumber?: string;
    birthdate?: any;
    address?: string;
    /** @example 90 */
    lat?: number | null;
    /** @example 180 */
    lng?: number | null;
    /** @example 180 */
    /**
     * Required with lat or lng
     */
    provider_id?: string;
    /**
     * @example google
     * @example manual
     * @example openstreetmaps
     * @example apple
     *
     * Required with lat or lng
     */
    provider?: string;
    addressComplement?: any;
    city?: string;
    postalCode?: string;
    country?: string;
    diploma?: {
        id?: number;
        name?: string;
    };
    societyName?: string;
    isSociety?: boolean;
    redirectUrl: string;
}

export interface IProfileExtraResponse {
    user: IExtraUser;
}

export interface IExtraProfileFeatures {
    URSSAFremunerationDeclaration: boolean;
    URSSAFattestation: boolean;
}

export interface IExtraUserData {
    email_signature: string;
    email?: string;
    firstname?: string;
    lastname?: string;
    birthdate?: string;
    isSociety?: boolean;
    societyName: string | null;
    address?: string;
    addressMore?: any;
    searchAddress?: string;
    longitude?: number;
    latitude?: number;
    radiusMission?: number;
    picture?: string;
    phoneNumber?: string;
    /** @deprecated use companyNumber */
    siret?: string;
    companyNumber?: string;
    companyRegistrationCountry: string | null;
    averageRate?: number;
    isHolidaysMode?: boolean;
    confirmed: boolean;
    blocked: boolean;
    isTestUser: boolean;
    balance_payout?: number;
    tva?: number;
    address_details?: AddressDetails;
    diploma?: any;
    experience?: any;
    nbRatings?: number;
    nbWorkedMissions?: number;
    preferenceLang?: string;
    can_sponsor_at?: string;
    code_sponsor?: string;
    code_sponsor_encoded?: string;
    nbReferrals?: number;
    sponsorAmountGained: IAmount;
    sponsorTotalGained?: number;
    sponsorFirstMissionRewardRedeemable: boolean | null;
    isGodson: boolean | null;
    reliability: number;
    /** @deprecated use hasFeatures */
    show_urssaf_attestation: boolean;
    nationality: string | null;
    hasFeatures: IExtraProfileFeatures;
}

export interface IPossibleRequestedChangesFromExtra {
    address?: boolean;
    birthdate?: boolean;
    email?: boolean;
    firstName?: boolean;
    lastName?: boolean;
    society?: boolean;
    phoneNumber?: boolean;
}

export interface IExtraUser {
    data: IExtraUserData;
    /** @example https://sca.sandbox.mangopay.com/?token=sca_0197a24fce967978b2b5227d347d3d06&returnUrl=http://onestaff.local/ */
    confirmActionURL: string | null;
    validationStep: number;
    validationItems: ValidationItems | null;
    requestedChanges?: IPossibleRequestedChangesFromExtra;
}

export enum DocumentValidationStatus {
    REFUSED = 'REFUSED',
    VALIDATED = 'VALIDATED',
    VALIDATION_ASKED = 'VALIDATION_ASKED',
}

export interface ValidationItems {
    acceptedRules: boolean;
    confirmed: boolean;
    siret: boolean;
    address: boolean;
    searchAddress: boolean;
    image: boolean;
    identityProof: DocumentValidationStatus | null;
    registrationDocument: DocumentValidationStatus | null;
}
